export default "__VITE_ASSET__444fde7e__"